// Module
var code = "<div> <div class=\"name\">My Incomplete reviews in Current Phase</div> </div> ";
// Exports
export default code;